import React from "react";

const HomeCollection = () => {
  return <div>Home Collection</div>;
};

export default HomeCollection;
